var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-icon flex-shrink-0 btn-round",class:_vm.isFavourite ? 'btn-primary' : 'btn-secondary',attrs:{"disabled":_vm.disabled},on:{"click":_vm.setFavourite}},[_c('icon',{attrs:{"icon":"fa-solid fa-heart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }